import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceChangeRoleMembershipFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { memberships: Array<(
    { __typename: 'Organization_Membership' }
    & Pick<Types.Organization_Membership, 'id' | 'idMember' | 'memberType'>
  )> }
);

export const WorkspaceChangeRoleMembershipFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceChangeRoleMembership' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'memberships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idMember' } },
                { kind: 'Field', name: { kind: 'Name', value: 'memberType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceChangeRoleMembershipFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceChangeRoleMembershipFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceChangeRoleMembershipFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceChangeRoleMembershipFragment>,
    'data'
  > {
  data?: WorkspaceChangeRoleMembershipFragment;
}

export const useWorkspaceChangeRoleMembershipFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceChangeRoleMembershipFragmentOptions): UseWorkspaceChangeRoleMembershipFragmentResult => {
  const result = Apollo.useFragment<WorkspaceChangeRoleMembershipFragment>({
    ...options,
    fragment: WorkspaceChangeRoleMembershipFragmentDoc,
    fragmentName: 'WorkspaceChangeRoleMembership',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as WorkspaceChangeRoleMembershipFragment,
  };
};
